export function DashboardIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <rect x="1" y="1" width="6" height="6" rx="1" />
      <rect x="9" y="1" width="6" height="6" rx="1" />
      <rect x="1" y="9" width="6" height="6" rx="1" />
      <rect x="9" y="9" width="6" height="6" rx="1" />
    </svg>
  );
}

export function TasksIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M2 3h12v2H2zm0 4h12v2H2zm0 4h7v2H2z" />
    </svg>
  );
}

export function EarningsIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M8 1a7 7 0 100 14A7 7 0 008 1zm1 10.93V13H7v-1.07A3 3 0 015 9h1.5a1.5 1.5 0 003 0c0-.83-.67-1.5-1.5-1.5A3 3 0 015 4.07V3h2v1.07A3 3 0 0111 7H9.5a1.5 1.5 0 00-3 0c0 .83.67 1.5 1.5 1.5A3 3 0 019 11.93z" />
    </svg>
  );
}

export function ProfileIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <circle cx="8" cy="5" r="3" />
      <path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6H2z" />
    </svg>
  );
}

export function ErrorIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M4.4 3L3 4.4 6.6 8 3 11.6 4.4 13 8 9.4 11.6 13 13 11.6 9.4 8 13 4.4 11.6 3 8 6.6z" />
    </svg>
  );
}
export function NotFoundIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M4 1h5l3 3v11H4V1zm5 1.5V5h2.5L9 2.5z" />
      <circle cx="6.5" cy="8" r="1" />
      <circle cx="9.5" cy="8" r="1" />
      <rect x="6" y="10.5" width="4" height="1.25" rx="0.6" />
    </svg>
  );
}
export function ShieldIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M8 1l5 2v4c0 3.8-2.3 6.5-5 8-2.7-1.5-5-4.2-5-8V3l5-2z" />
    </svg>
  );
}
export function PadlockIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M5 7V5a3 3 0 116 0v2h1v8H4V7h1zm2-2v2h2V5a1 1 0 10-2 0z" />
    </svg>
  );
}
export function SearchIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M7 2a5 5 0 103.54 8.54l2.96 2.96a1 1 0 001.41-1.41l-2.96-2.96A5 5 0 007 2zm0 2a3 3 0 110 6 3 3 0 010-6z" />
    </svg>
  );
}
